"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectUserProfile = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectUserProfile = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectUserProfile, _super);
    function IkeObjectUserProfile() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.className = 'UserProfile';
        _this.actionName = 'user.profile';
        return _this;
    }
    return IkeObjectUserProfile;
}(base_1.IkeRestObject));
exports.IkeObjectUserProfile = IkeObjectUserProfile;
//# sourceMappingURL=user.profile.object.js.map